/**
 * Coalesce concurrent async work by key (in-flight only).
 * Not a cache — entries are removed when the promise settles.
 */
const inflight = new Map();

export function coalesceAsync(key, fn) {
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fn)
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, promise);
  return promise;
}
